import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
//import { showProfileDriverEmailModal, hideProfileDriverEmailModal } from '../../store/profile/action';
import { useDispatch, useSelector } from 'react-redux';
import { Chip } from '@material-ui/core';
import { getCheckoutSelectAddressState } from '../../../store/buyPermits/selector';
import { getCheckoutSelectAddressStates, hideCheckoutSelectBillingAddressModal, setCheckoutSelectedAddress, setCheckoutSelectedBillingAddress } from '../../../store/buyPermits/action';



const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,       
  },
  btnConfirm: {
    paddingLeft: 8,
    paddingRight: 8,
    borderRadius:10,
    height:23,
  },
  btnRow: {
    textAlign: 'right',
    marginTop: 20,
  },
}));

const emailData=[{
  "id": 112,
  "defaultFlag": true,
  "line1": "H6",
  "line2": "156",
  "city": "Noida",
  "state": {
      "code": "AK"
  },
  "zip": "22341",
  "inactive": false
},{
"id": 113,
"defaultFlag": false,
"line1": "Lucknow",
"line2": "156",
"city": "Noida",
"state": {
    "code": "AK"
},
"zip": "22341",
"inactive": true
},{
  "id": 114,
  "defaultFlag": false,
  "line1": "Kanpur",
  "line2": "156",
  "city": "Noida",
  "state": {
      "code": "AK"
  },
  "zip": "22341",
  "inactive": false
  }];

export default function SelectBillingAddressModalForm(props) {
  const classes = useStyles();
  
  const dispatch=useDispatch();
  const getCheckoutSelectAddressStateData = useSelector((state) => state?.exitOrderReducer?.checkoutSelectAddressState);
  const [MyEmailData, setMyEmailData] = useState(Array.isArray(getCheckoutSelectAddressStateData) && getCheckoutSelectAddressStateData)
 

  const {CloseSelectBillingAddressModal,handleOpenAddBillingAddressModal}=props;

  useEffect(() => {
    const ActiveData = Array.isArray(getCheckoutSelectAddressStateData) && getCheckoutSelectAddressStateData.filter((items) => {
      return items.inactive === false
    })
    setMyEmailData(ActiveData)
  }, [getCheckoutSelectAddressStateData])

  const [selectedBillingAddress,setSelectedBillingAddress]=useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleOpenCheckoutBillingAddressModal = (ele,e)=>{
    setSelectedBillingAddress(ele);  
    setSelectedIndex(ele.id);
  }

  const SetCheckoutBillingAddress = (ele)=>{
    dispatch(setCheckoutSelectedBillingAddress(selectedBillingAddress));
    dispatch(hideCheckoutSelectBillingAddressModal());
  }  
 
  if(MyEmailData && MyEmailData.length>0) {
    return (
      <>
        <List className={classes.root}>
            {MyEmailData.map((ele)=>{
              if(ele.defaultFlag===true){
                return(
                  <>
                    <ListItem key={ele.id} 
                     onClick={(e)=>handleOpenCheckoutBillingAddressModal(ele,e)}
                     //style={bgColor}  
                     selected={selectedIndex === ele.id}                
                    >
                      <ListItemText primary={ele.line1}/>
                      {ele.defaultFlag===true?<Chip label="Default"/>:''}
                    </ListItem>
                    <Divider /> 
                  </>   
                )
              }
            })}
            {MyEmailData.map((ele)=>{
                if(ele.defaultFlag===false){
                  return(
                      <>
                      <ListItem key={ele.id} 
                        onClick={(e)=>handleOpenCheckoutBillingAddressModal(ele,e)}
                       // style={bgColor}
                       selected={selectedIndex === ele.id}
                      >
                        <ListItemText primary={ele.line1}/>
                        {ele.defaultFlag===true?<Chip label="Default"/>:''}
                      </ListItem>
                      <Divider /> 
                      </>   
                  )
                }
            })}                                            
        </List>   
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.btnRow} >
            <Button color="primary" variant="text"
              onClick={handleOpenAddBillingAddressModal}
             >Add Address</Button>
            <Button onClick={CloseSelectBillingAddressModal}>Cancel</Button>
            <Button onClick={SetCheckoutBillingAddress} variant="contained" type={'submit'} color="primary" className={classes.btnConfirm}>
              Confirm
            </Button>
          </Grid>
        </Grid>     
      </>
    );
  } else {
    return (
      <>
        <List className={classes.root}>
          <ListItem>
            <div>Address not Found</div>
          </ListItem>
        </List>
      </>
    );
  }
}
